import { LayoutEnum } from '@goldcast/api/content';
import { LayoutStatus } from '../types/asset-types';
import { Clip } from '../types/clip-types';
import { isLayoutWithVisionDataEnabledPure } from './clipUtils';

export const getLayoutAvailabilityStatusPure = ({
  clip,
  clipLayout,
  layoutStatus,
  useNewPlayer = false,
  isFullFaceRecEnabled,
  isFullFaceRecForPreRecordedEnabled
}: {
  clipLayout: LayoutEnum;
  layoutStatus: Clip['layout_status'];
  clip: Clip;
  useNewPlayer: boolean;
  isFullFaceRecEnabled: boolean;
  isFullFaceRecForPreRecordedEnabled: boolean;
}) => {
  if (
    useNewPlayer &&
    !isLayoutWithVisionDataEnabledPure({ clip, isFullFaceRecEnabled, isFullFaceRecForPreRecordedEnabled })
  ) {
    return null;
  }

  if (!(clipLayout === 'SPEAKER' || clipLayout === 'GRID' || clipLayout === 'FOCUS')) {
    return null;
  }
  const speakerLayoutStatusInfo = layoutStatus[clipLayout === 'FOCUS' ? 'GRID' : clipLayout] as LayoutStatus;

  if (speakerLayoutStatusInfo.status === 'DONE') {
    if (speakerLayoutStatusInfo.accurate === false) {
      return 'PROCESSING';
    }

    return 'DONE';
  }

  if (
    speakerLayoutStatusInfo.status === 'PROCESSING' ||
    speakerLayoutStatusInfo.status === 'FAILED' ||
    speakerLayoutStatusInfo.status === 'UNAVAILABLE'
  ) {
    return speakerLayoutStatusInfo.status;
  }

  return null;
};
